import { trackMixpanel } from '../base';
import type { CarouselBaseProps } from './types';

const COMPONENT = 'Deliveries Carousel';
const EVENT_NAME = 'End of feed';

export interface CarouselEndOfFeedProps extends CarouselBaseProps {}

interface CarouselEndOfFeedMixpanelProps {
    'Page Name': string;
    'Carousel Name': string;
    'Subcategory IDs': number[];
    'Number Of Saved Deliveries': number;
}

export const trackCarouselEndOfFeed = (props: CarouselEndOfFeedProps) => {
    trackMixpanel(COMPONENT, EVENT_NAME, {
        'Page Name': props.pageName,
        'Carousel Name': props.carouselName,
        'Subcategory IDs': props.subCategoryIds,
        'Number Of Saved Deliveries': props.numberOfSavedDeliveries,
    } satisfies CarouselEndOfFeedMixpanelProps);
};
